<template>
  <div class="managenment_box">
    <div class="managenment">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="form" label-width="auto">
           
            <el-form-item>
              <div class="block" style="margin-left:20px;">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  @change="onPick"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                ></el-date-picker>
              </div>
            </el-form-item>

            <el-form-item>
              <el-input
                v-model="params.account_number"
                placeholder="请输入代理账号"
                class="myInput"
                style="width:300px"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-input
                v-model="params.agent_name"
                placeholder="请输入代理昵称 "
                class="myInput"
                style="width:300px"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="goon"
                icon="el-icon-search"
                @click="search()"
                style="margin-left:20px"
              ></el-button>
            </el-form-item>
          </el-form>

          <!-- <div class="tableList">提现记录列表</div> -->
          <div style="margin-right:20px;margin-left:20px;margin-top:20px">
             <div class="tableList">提现审核表</div>
            <el-table
              class="tableBox"
              :header-cell-style="{background:'#F1F6F9',color:'#606266',width: '100%'}"
              :data="tableData"
              border
            >
              <el-table-column label="代理账号" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.account_number}}</span>
                </template>
              </el-table-column>

              <el-table-column label="代理昵称" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.agent_name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="支付宝名称" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.alipay_name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="支付宝账号" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.alipay_accout}}</span>
                </template>
              </el-table-column>
              <el-table-column label="身份证号码" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.card}}</span>
                </template>
              </el-table-column>
              <el-table-column label="电话" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.phone}}</span>
                </template>
              </el-table-column>

              <el-table-column label="提现金额" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.money}}</span>
                </template>
              </el-table-column>

              <el-table-column label="提现时间" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.create_date}}</span>
                </template>
              </el-table-column>

              <el-table-column label="提现状态" align="center" :render-header="renderEmotionValue"  style="color:red">

                <template slot-scope="scoope">
                  <el-button type="danger" plain size="mini" v-if="scoope.row.is_put == 0" disabled> 未打款</el-button>
                  <el-button type="success" plain size="mini" v-else disabled>已打款</el-button >
                </template>




              </el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scoope">
                  <el-button
                    type="danger"
                    plain
                    size="mini"
                    v-if="scoope.row.is_put == 0"
                    @click="unsettledPayment(scoope)"
                  >未打款</el-button>
                  <el-button type="success" size="mini" v-else disabled>已打款</el-button>
                </template>
              </el-table-column>


            </el-table>
          </div>
        </el-col>
        <el-dialog
          title="打款"
          :visible.sync="remitVisible"
          width="30%"
          center>
          <el-form
                :model="remitForm"
                :rules="rules"
                ref="remitForm"
                 :inline="true"
                 label-width="180px"
              >
              <el-form-item  prop="remit_type" label="付款账户类型：" >
                 <el-select v-model="remitForm.remit_type">
                    <el-option v-for="item in remit_types" :key="item.label" :label="item.label" :value="item.label"></el-option>
                  </el-select>  
              </el-form-item>
              <el-form-item  prop="remit_order" label="付款流水号：">
                 <el-input  placeholder="请输入付款流水号" v-model="remitForm.remit_order"/>
              </el-form-item>
              <el-form-item  prop="remit_service_charge" label="手续费：">
                 <el-input  placeholder="请输入手续费" v-model="remitForm.remit_service_charge"/>
              </el-form-item>
              <el-form-item  prop="remit_real_amount" label="实际到账金额：">
                 <el-input  placeholder="请输入实际到账金额" v-model="remitForm.remit_real_amount"/>
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="remitVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureRemit('remitForm')">确 定</el-button>
          </span>
        </el-dialog>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="count"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-row>
    </div>
  </div>
</template>
<script >
import * as sysApi from "../../common/sys";
export default {
  data() {
    return {
      rules: {
        remit_type: [
          { required: true, message: "请选择付款账户类型", trigger: "blur" },
        ],
        remit_order: [
          { required: true, message: "请输入付款流水号", trigger: "blur" },
        ],
        remit_service_charge: [
          { required: true, message: "请输入付款流水号", trigger: "blur" },
        ],
        remit_real_amount: [
          { required: true, message: "请输入付款流水号", trigger: "blur" },
        ],
      },
      remitVisible: false,
      remitId: "",
      remitForm: {
        remit_type: "",
        remit_order: "",
        remit_service_charge: "",
        remit_real_amount: "",
      },
      remit_types: [
        {
          label: "开放平台灵活用工",
        },
        {
          label: "微信",
        },
        {
          label: "支付宝",
        },
        {
          label: "银行卡",
        },
      ],

      value1: "", // 时间日期 v-model
      tableData: [], // 数据列表
      params: {
        //  接口默认参数
        end_at: "",
        page: 1,
        start_at: "",
        account_number: "",
        agent_name: "",
        is_put: 2,
      },
      form: {
        status: "全部",
        account_number: "",
        start_time: "",
        end_time: "",
        start: "",
        agent_name: "",
        page: 1, // 页数
      },
      count: 0,
    };
  },

  mounted() {
    this.initQuery();
  },
  created() {},
  methods: {
    initQuery() {
      sysApi
        .admin_apply_money_rude(this.params)
        .then((res) => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          this.tableData = res.result;
          this.count = res.count;
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    sureRemit(formName) {
      this.$refs[formName].validate((valid) => {
        this.remitForm.remit_service_charge = Number(
          this.remitForm.remit_service_charge
        );
        this.remitForm.remit_real_amount = Number(
          this.remitForm.remit_real_amount
        );
        let params = {
          id: this.remitId,
          status: 1,
          ...this.remitForm,
        };
        if (valid) {
          sysApi
            .admin_alipay_status(params)
            .then((res) => {
              if (res.code == 1) {
                this.remitVisible = false;
                this.initQuery();

                this.$message.success("打款成功!");
              }
            })
            .catch((err) => console.log("请求异常信息:" + err));
        }
      });
    },
    // 未打款
    unsettledPayment(value) {
      this.remitVisible = true;
      this.remitId = value.row.id;
      // let is_put = value.row.is_put;
      // let params = { id: id, status: 1};
      // this.$confirm(`是否将, ${account_number}确认打款?`, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     sysApi
      //       .admin_alipay_status(params)
      //       .then(res => {
      //         if (res.code != 1) {
      //           return this.$message.error(res.result);
      //         }
      //     this.initQuery();
      //         this.$message({
      //           type: "success",
      //           message: "打款成功!"
      //         });
      //       })
      //       .catch(err => console.log("请求异常信息:" + err));
      //   })
      //   .catch(() => {});
    },
    // 时间
    onPick(val) {
      console.log(val);
      this.params.start_at = val[0];
      this.params.end_at = val[1];
      this.initQuery();
    },
    search() {
      this.initQuery();
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.initQuery();
    },

    renderEmotionValue(creatElement, { column, $index }) {
      return (
        <el-dropdown onCommand={this.handleCommand}>
          <span class="el-dropdown-link">
            打款状态 <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="2">全部</el-dropdown-item>
            <el-dropdown-item command="1">已打款</el-dropdown-item>
            <el-dropdown-item command="0">未打款</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      );
    },
    handleCommand(command) {
      this.params.is_put = Number(command);

      this.initQuery();
    },
  },
};
</script>
<style >
.el-dialog__header {
  background: #f3f3f3 !important;
}
.el-dialog__title {
  color: #606266 !important;
  text-align: center;
  width: 100%;

  display: inline-block;
}
</style>
<style scoped lang="scss">
.modify {
  color: red;

  padding-left: 20px;
  cursor: pointer;
}
.managenment_box {
  .managenment {
    //   margin: 0 auto;
    // text-align: center;

    .bg-purple {
      border-right: 10px solid #f3f3f3;
      //  border-bottom: 10px solid #f3f3f3;
      .price_manage {
        text-align: center;
        padding-left: 20px;
        padding-top: 20px;
        // border-right: 10px solid #f3f3f3;

        padding-bottom: 10px;
        .price_money {
          text-align: left;
          color: #343434;
          font-size: 16px;
          font-weight: bold;
          padding-bottom: 40px;
        }
        .money {
          color: #ff3149;
          font-size: 36px;
          font-weight: bold;
          padding-bottom: 30px;
        }
        .withdraw_btn {
          width: 138px;
          height: 38px;
        }
        .rule {
          color: #4c4c4c;
          font-size: 12px;
          padding-top: 20px;
          cursor: pointer;
        }
      }
      .withdrawal_box {
        border-top: 10px solid #f3f3f3;
        height: 361px;
        .withdrawal {
          padding: 20px 0 0 20px;
          font-size: 16px;
          font-weight: bold;
          color: #343434;
        }
        .block {
          padding: 40px 0px 0 45px;
        }
      }
    }
  }
  .grid-content {
    .listHeader {
      font-size: 18px;
      color: #2f2f2f;
      font-weight: bold;
      padding: 20px 0;
      text-align: center;
    }
  }
}
.el-form-item {
  margin-top: 20px !important;
}
.getShort {
  position: relative;
  .getCode {
    position: absolute;
    top: 3px;
    right: 82px;
    color: #7495b7;
    font-size: 14px;
    background: #f8fbff;
    height: 35px;
    width: 122px;
    line-height: 35px;
    border-left: 1px solid #e3e3e3;
    cursor: pointer;
  }
}
.my_span {
  width: 90px;
  display: inline-block;
  text-align: right;
  padding-right: 20px;
}
.amount {
  color: #df4444;
  font-size: 18px;
}
.tableList {
  border: 1px solid #ebeef5;
  border-bottom: 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  height: 49px;
  line-height: 49px;
  background: #f1f6f9;
}

.tableBox {
  margin-right: 20px;
}
</style>
